











































































import eventBus from '@/utils/eventBus';
import { Component, Watch } from 'vue-property-decorator';
import GuidedTourTemplate from './GuidedTourTemplate.vue';
import { sleep } from '@/utils';
import CloseModalIcon from '@/components/icons/CloseModal.vue';
import { FilledButton } from '@/components/molecules';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    CloseModalIcon,
    FilledButton
  }
})
export default class BillingGuidedTour extends GuidedTourTemplate {
  tourName: string = 'billingGuidedTour';
  stepParamsName = 'data-v-step-billing-tour';

  steps: any = [
    {
      target: '[data-v-step-billing-tour="1"]',
      header: {
        title: `Coin Network icon`
      },
      content: `This icon will indicate that your business is within the Coin Network.`,
      cloneStyle: {
        borderRadius: '50%'
      },
      params: {
        placement: this.$mobileCheck() ? 'bottom' : 'right-start'
      },
      before: async () => {
        this.onHideStep();

        if (this.$mobileCheck()) {
          eventBus.$emit('toggleLeftBarMobile', true);
          await sleep(300);
        }
        segmentIo.track('Viewed Billing Guided Tour Step 1', {
          'Number Of Steps': this.steps.length
        });

        this.onShowStep();
      }
    },
    {
      target: '[data-v-step-billing-tour="2"]',
      header: {
        title: `Coin Network feature`
      },
      content: `This icon indicates features associated with the Coin Network.`,
      cloneStyle: {
        borderRadius: '50%'
      },
      params: {
        placement: this.$mobileCheck() ? 'bottom' : 'right-start'
      },
      before: async () => {
        this.onHideStep();
        if (this.$mobileCheck()) {
          eventBus.$emit('toggleLeftBarMobile', false);
        }

        const tasks = this.$store.getters['startGuide/getTasks'];
        if (tasks) {
          const firstCoinNetwork = tasks.findIndex(
            (task: any) => task.coinNetwork
          );
          eventBus.$emit('slideStartGuide', {
            goToIndex: firstCoinNetwork
          });
          await sleep(600);
        }
        segmentIo.track('Viewed Billing Guided Tour Step 2', {
          'Number Of Steps': this.steps.length
        });
        this.onShowStep();
      }
    },
    {
      target: '[data-v-step-billing-tour="3"]',
      header: {
        title: `First Coins minting`
      },
      content: `This date indicates when your business will start minting Coins for Twism.`,
      cloneStyle: {
        borderRadius: '8px'
      },
      params: {
        placement: this.$mobileCheck() ? 'bottom' : 'right-start'
      },
      before: async () => {
        this.onHideStep();
        if (this.$mobileCheck()) {
          eventBus.$emit('toggleLeftBarMobile', true);
          await sleep(300);
        }

        segmentIo.track('Viewed Billing Guided Tour Step 3', {
          'Number Of Steps': this.steps.length
        });
        this.onShowStep();
      }
    },
    {
      target: '[data-v-step-billing-tour="4"]',
      header: {
        title: `Plan overview`
      },
      content: `Access details of your Coin Network Plan and your Coins minting process.`,
      cloneStyle: {
        borderRadius: '8px'
      },
      params: {
        placement: this.$mobileCheck() ? 'bottom' : 'right-start'
      },
      before: async () => {
        this.onHideStep();
        if (this.$mobileCheck()) {
          eventBus.$emit('toggleLeftBarMobile', true);
        }
        eventBus.$emit('leftBarCollapseGroup', 'business-menu');
        await sleep(200);

        segmentIo.track('Viewed Billing Guided Tour Step 4', {
          'Number Of Steps': this.steps.length
        });
        this.onShowStep();
      }
    }
  ];

  finish() {
    const element = document.querySelector('.container-col');

    if (element && window.innerWidth <= 1280) {
      element.toggleAttribute('data-expanded');
    }
  }

  @Watch('activedTour')
  async changedActivedTourProp() {
    if (this.tourName === this.activedTour) {
      if (this.$route.name !== 'home') {
        this.$router.push('/home');
      }
      await sleep(100);
      this.steps = this.steps.filter((item: any) => {
        return !!document.querySelector(item.target);
      });
      const element = document.querySelector('.container-col');

      if (element && window.innerWidth >= 820 && window.innerWidth <= 1280) {
        element.toggleAttribute('data-expanded');
      }

      if (this.$mobileCheck()) {
        eventBus.$emit('toggleLeftBarMobile', true);
      }
    }
  }
}
